import { default as isValidDomainLib } from 'is-valid-domain';
/**
 * Takes a string and checks if it is a valid domain.
 */
export var isValidDomain = function (domain) {
    return isValidDomainLib(domain, { subdomain: true });
};
/**
 * Check if it's any domain, without www. prefix
 *
 * @param domain string
 */
export var isBasicValidDomain = function (domain) {
    if (domain.toLowerCase().startsWith('www.')) {
        return false;
    }
    return isValidDomain(domain);
};
/**
 * Takes a URL string and removes https, http, www or the combination of previous ones.
 * Additionally, removes '/' in the end of the string and lowercases it.
 */
export var serializeRawDomain = function (domain) {
    return domain
        .replace(/^(https?:\/\/(?:www\.|(?!www)))|^(www\.)/, '')
        .replace(/\/$/, '')
        .toLocaleLowerCase();
};
var withHttp = function (url) {
    return url.replace(/^(?:(.*:)?\/\/)?(.*)/i, function (match, schema, nonSchemaUrl) {
        return schema ? match : "http://".concat(nonSchemaUrl);
    });
};
var getDomainWithoutSubdomain = function (string) {
    var urlParts = new URL(string).hostname.split('.');
    return urlParts
        .slice(0)
        .slice(-(urlParts.length === 4 ? 3 : 2))
        .join('.');
};
export var extractDomainFromString = function (string) {
    try {
        var hostname = getDomainWithoutSubdomain(withHttp(string));
        if (isValidDomain(hostname)) {
            return hostname;
        }
        return undefined;
    }
    catch (_a) {
        return undefined;
    }
};
export var attemptToFixDomain = function (maybeDomain, onFixedCallback) {
    if (!maybeDomain) {
        return maybeDomain;
    }
    var isValidDomain = isBasicValidDomain(maybeDomain);
    if (isValidDomain) {
        return serializeRawDomain(maybeDomain);
    }
    var maybeFixedDomain = extractDomainFromString(maybeDomain);
    if (maybeFixedDomain) {
        var serializedFixedDomain = serializeRawDomain(maybeFixedDomain);
        if (onFixedCallback) {
            onFixedCallback(maybeDomain, serializedFixedDomain);
        }
        return serializedFixedDomain;
    }
    return maybeDomain;
};
//# sourceMappingURL=domains.js.map